import React from 'react'; // eslint-disable-line
import { select } from 'redux-saga/effects';

import { changeBoard } from '../events';
// eslint-disable-next-line import/no-cycle
import store from '../store';
import * as actions from '../state';

import deleteBoardService from './services/board/deleteBoard';
import fetchBoardListService from './services/board/fetchBoardList';

export default function* deleteBoard(event) {
  try {
    const user = yield select((state) => actions.readStateUser(state));

    const { intl } = event.payload;
    const { messages } = event.payload;

    const boardService = deleteBoardService({
      user: user.userId,
      domain: user.domain,
      board: event.payload.board,
    });

    boardService.then((result) => {
      try {
        if (!result) {
          throw intl.formatMessage({ ...messages.DELETE_FAILED });
        }

        fetchBoardListService({ // update boardlist
          domain: user.domain,
        }).then((boardList) => {
          store.dispatch(actions.setBoardList(boardList));
          if (boardList && boardList.length) {
            store.dispatch(changeBoard(boardList[0].id));
          } else {
            store.dispatch(changeBoard());
          }
          store.dispatch(actions.isDirty(false));
          store.dispatch(actions.savedBoardState(false));
          store.dispatch(actions.editMode(false));
        });
      } catch (error) {
        store.dispatch(actions.isLoading(false));
        store.dispatch(actions.showToaster({
          show: true,
          type: 'error',
          message: error,
        }));
      }
    });
  } catch (error) {
    store.dispatch(actions.showToaster({
      show: true,
      type: 'error',
      message: error,
    }));
  }
}
